export const idlFactory = ({ IDL }) => {
  const PaymentDestination = IDL.Variant({
    'SellerAccount' : IDL.Text,
    'StationTreasury' : IDL.Principal,
  });
  const Result = IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text });
  const ProposalError = IDL.Variant({
    'AlreadyVoted' : IDL.Nat64,
    'InvalidTransferDetails' : IDL.Text,
    'NotActive' : IDL.Null,
    'NotFound' : IDL.Nat64,
    'Custom' : IDL.Text,
    'NoStationLinked' : IDL.Principal,
    'IcCallFailed' : IDL.Record({ 'code' : IDL.Int32, 'message' : IDL.Text }),
    'OrbitError' : IDL.Record({
      'code' : IDL.Text,
      'message' : IDL.Text,
      'details' : IDL.Opt(IDL.Text),
    }),
    'ActiveProposalExists' : IDL.Null,
    'InsufficientVotingPowerToPropose' : IDL.Record({
      'required' : IDL.Nat64,
      'current' : IDL.Nat64,
    }),
    'ZeroVotingPower' : IDL.Null,
    'NoVotingPower' : IDL.Null,
    'Expired' : IDL.Null,
    'AuthRequired' : IDL.Null,
  });
  const Result_1 = IDL.Variant({ 'Ok' : IDL.Nat64, 'Err' : ProposalError });
  const Result_2 = IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text });
  const EquityProposalStatus = IDL.Variant({
    'Approved' : IDL.Null,
    'Proposed' : IDL.Null,
    'Executed' : IDL.Null,
    'Expired' : IDL.Null,
  });
  const EquityTransferProposal = IDL.Record({
    'status' : EquityProposalStatus,
    'no_votes_pct' : IDL.Nat8,
    'payment_destination' : PaymentDestination,
    'created_at' : IDL.Nat64,
    'seller' : IDL.Principal,
    'ckusdc_amount' : IDL.Nat64,
    'proposal_id' : IDL.Text,
    'station_id' : IDL.Principal,
    'buyer' : IDL.Principal,
    'expires_at' : IDL.Nat64,
    'yes_votes_pct' : IDL.Nat8,
    'percentage' : IDL.Nat8,
  });
  const ProposalStatus = IDL.Variant({
    'Active' : IDL.Null,
    'Rejected' : IDL.Null,
    'Executed' : IDL.Null,
    'Expired' : IDL.Null,
  });
  const OrbitOperationType = IDL.Variant({
    'RemoveAsset' : IDL.Null,
    'AddUserGroup' : IDL.Null,
    'EditPermission' : IDL.Null,
    'SnapshotExternalCanister' : IDL.Null,
    'PruneExternalCanister' : IDL.Null,
    'EditNamedRule' : IDL.Null,
    'ConfigureExternalCanister' : IDL.Null,
    'ChangeExternalCanister' : IDL.Null,
    'MonitorExternalCanister' : IDL.Null,
    'AddUser' : IDL.Null,
    'EditAsset' : IDL.Null,
    'EditUserGroup' : IDL.Null,
    'SetDisasterRecovery' : IDL.Null,
    'EditRequestPolicy' : IDL.Null,
    'RemoveRequestPolicy' : IDL.Null,
    'AddAsset' : IDL.Null,
    'SystemUpgrade' : IDL.Null,
    'RemoveAddressBookEntry' : IDL.Null,
    'SystemRestore' : IDL.Null,
    'CreateExternalCanister' : IDL.Null,
    'EditAddressBookEntry' : IDL.Null,
    'FundExternalCanister' : IDL.Null,
    'EditUser' : IDL.Null,
    'ManageSystemInfo' : IDL.Null,
    'Transfer' : IDL.Null,
    'EditAccount' : IDL.Null,
    'AddAddressBookEntry' : IDL.Null,
    'RemoveUser' : IDL.Null,
    'Other' : IDL.Text,
    'AddRequestPolicy' : IDL.Null,
    'RemoveNamedRule' : IDL.Null,
    'RemoveUserGroup' : IDL.Null,
    'CallExternalCanister' : IDL.Null,
    'AddNamedRule' : IDL.Null,
    'RestoreExternalCanister' : IDL.Null,
    'AddAccount' : IDL.Null,
  });
  const TransferDetails = IDL.Record({
    'to' : IDL.Text,
    'title' : IDL.Text,
    'from_account_id' : IDL.Text,
    'memo' : IDL.Opt(IDL.Text),
    'description' : IDL.Text,
    'amount' : IDL.Nat,
    'from_asset_id' : IDL.Text,
  });
  const UnifiedProposal = IDL.Record({
    'id' : IDL.Nat64,
    'status' : ProposalStatus,
    'yes_votes' : IDL.Nat64,
    'operation_type' : OrbitOperationType,
    'created_at' : IDL.Nat64,
    'token_canister_id' : IDL.Principal,
    'orbit_request_id' : IDL.Text,
    'proposer' : IDL.Principal,
    'voter_count' : IDL.Nat32,
    'total_voting_power' : IDL.Nat64,
    'no_votes' : IDL.Nat64,
    'expires_at' : IDL.Nat64,
    'transfer_details' : IDL.Opt(TransferDetails),
  });
  const VoteChoice = IDL.Variant({ 'No' : IDL.Null, 'Yes' : IDL.Null });
  const Result_3 = IDL.Variant({ 'Ok' : IDL.Null, 'Err' : ProposalError });
  return IDL.Service({
    'create_equity_transfer_proposal' : IDL.Func(
        [IDL.Principal, IDL.Principal, IDL.Nat8, IDL.Nat64, PaymentDestination],
        [Result],
        [],
      ),
    'ensure_proposal_for_request' : IDL.Func(
        [IDL.Principal, IDL.Text, IDL.Text],
        [Result_1],
        [],
      ),
    'execute_equity_transfer' : IDL.Func([IDL.Text], [Result_2], []),
    'get_equity_holders' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Nat8))],
        ['query'],
      ),
    'get_equity_transfer_proposal' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(EquityTransferProposal)],
        ['query'],
      ),
    'get_equity_transfer_proposals' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(EquityTransferProposal)],
        ['query'],
      ),
    'get_proposal' : IDL.Func(
        [IDL.Principal, IDL.Text],
        [IDL.Opt(UnifiedProposal)],
        ['query'],
      ),
    'get_user_equity' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [IDL.Nat8],
        ['query'],
      ),
    'get_user_vote' : IDL.Func(
        [IDL.Principal, IDL.Principal, IDL.Text],
        [IDL.Opt(VoteChoice)],
        ['query'],
      ),
    'has_user_voted' : IDL.Func(
        [IDL.Principal, IDL.Principal, IDL.Text],
        [IDL.Bool],
        ['query'],
      ),
    'initialize_equity_station' : IDL.Func(
        [IDL.Principal, IDL.Principal],
        [Result_2],
        [],
      ),
    'is_equity_station' : IDL.Func([IDL.Principal], [IDL.Bool], ['query']),
    'list_unified_proposals' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(UnifiedProposal)],
        ['query'],
      ),
    'vote_on_equity_transfer' : IDL.Func([IDL.Text, IDL.Bool], [Result_2], []),
    'vote_on_proposal' : IDL.Func(
        [IDL.Principal, IDL.Text, IDL.Bool],
        [Result_3],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
